export default "/_next/static/media/heartIcon@3x.f4be81919fc6435b00ccf854bbbd77fd.png";